<script lang="ts">
  import { PdfViewer } from "svelte-pdf-simple";
  import type { PdfException, PdfLoadSuccess, PdfPageContent } from "svelte-pdf-simple";
  import { get } from "svelte/store";
  import { sid } from "../app.store";

  let pdfViewer: PdfViewer;
  let pageNumber = 0;
  let totalPages = 0;
  let isPdfLoaded = false;
  let password = "";

  export let url: string = "";
  export let scale: number = 1.0;

  function goToPage(page: number): void {
    pdfViewer.goToPage(page);
  }

  function handlePageChanged(event: CustomEvent<PdfPageContent>): void {
    pageNumber = event.detail.pageNumber;
  }

  function handleLoadedSuccess(event: CustomEvent<PdfLoadSuccess>) {
    totalPages = event.detail.totalPages;
    pageNumber = 1;
    isPdfLoaded = true;
  }

  function handleLoadFailure(event: CustomEvent<PdfException>) {
    // Put your logic on how to handle PDF loading failure
  }
</script>

{#if isPdfLoaded}
  <span style="margin-right:1rem;">Pagina {pageNumber}/{totalPages}</span>
  <button on:click={() => goToPage(pageNumber - 1)}>&lt; pag.</button>
  <button on:click={() => goToPage(pageNumber + 1)}>pag. &gt;</button>
{/if}
<PdfViewer
  bind:this={pdfViewer}
  props={{
    url: url,
    scale: scale,
    withAnnotations: true,
    withTextContent: true,
    httpHeaders: { Authorization: "Token " + get(sid) },
  }}
  style="border: 1px solid black; display: block; margin-top: 10px;"
  on:load_success={handleLoadedSuccess}
  on:load_failure={handleLoadFailure}
  on:page_changed={handlePageChanged}
>
  <svelte:fragment slot="loading">Caricamento PDF...</svelte:fragment>
  <!--
    <svelte:fragment slot="loading-failed">Well... something went wrong :(</svelte:fragment>
    <svelte:fragment slot="password-required">
      <p>This pdf is password protected. Please enter the password to view it.</p>
      <input type="password" bind:value={password} />
      <button on:click={() => pdfViewer.openWithPassword(password)}>unlock</button>
    </svelte:fragment>
    -->
</PdfViewer>
